import React from "react";
var GeneralSettings = function (_a) {
    var interval = _a.interval, setInterval = _a.setInterval;
    return (React.createElement("section", { className: "mb-5 md:mb-10" }));
};
export default GeneralSettings;
